import { Box } from '@mui/material';
import { RuleBuilder, RuleBuilderProvider } from '@procureai/rule-builder-ui-mui';
import { useParams } from 'react-router';

import { CircularProgressCentered } from '~/components/CircularProgressCentered/CircularProgressCentered.tsx';
import { useRuleEvaluationLogDetail } from '~/routes/RuleEvaluationLogDetail/RuleEvaluationLogDetail.hook.ts';

const RuleEvaluationLogDetailInner = () => {
  const { ruleId, logId } = useParams() as { ruleId: string; logId: string };

  const { data, variant, stats, loading } = useRuleEvaluationLogDetail({ ruleId, evaluationLogId: logId });

  return (
    <Box
      sx={{
        position: 'relative',
        height: '100%',
        width: '100%',
      }}
    >
      {loading ? <CircularProgressCentered /> : null}
      {data ? <RuleBuilder variant={variant} data={data} stats={stats} readonly /> : null}
    </Box>
  );
};

export const RuleEvaluationLogDetail = () => {
  return (
    <RuleBuilderProvider>
      <RuleEvaluationLogDetailInner />
    </RuleBuilderProvider>
  );
};
